<template>
  <div v-if="notificationActive" class="bg-br-green-light p-4" :style="style">
    <div class="fluid-xs leading-tightest font-medium">{{ notificationHeading }}</div>
    <div class="fluid-xs leading-tightest font-light mt-2" v-html="notificationBody"></div>
  </div>
</template>

<script>
import gql from 'graphql-tag';
import { useCartSettingsStore } from '@/stores/cart-settings';
import { storeToRefs } from 'pinia';

export const CartNotificationFragment = gql`
  fragment CartNotificationFragment on cartSettings_GlobalSet {
    notificationActive
    notificationFontColor
    notificationBackgroundColor
    notificationHeading
    notificationBody
  }
`;
export default defineNuxtComponent({
  setup() {
    const cartSettingsStore = useCartSettingsStore();

    const {
      notificationActive,
      notificationFontColor,
      notificationBackgroundColor,
      notificationHeading,
      notificationBody,
    } = storeToRefs(cartSettingsStore);

    return {
      notificationActive,
      notificationFontColor,
      notificationBackgroundColor,
      notificationHeading,
      notificationBody,
    };
  },

  computed: {
    style() {
      return {
        color: this.notificationFontColor,
        backgroundColor: this.notificationBackgroundColor,
      };
    },
  },
});
</script>
